import { i18n } from '@/plugins/i18n'
import yup from '@/plugins/yup'

const { t } = i18n.global

const MaintenanceReportSearchBarSchema = yup.object({
  period: yup
    .array()
    .of(yup.date().nullable())
    .required(
      t('errors.required', {
        label: t('maintenance_report.header.actions.search.fields.period'),
      }),
    )
    .test(
      'two-dates',
      t('errors.required', {
        label: t('maintenance_report.header.actions.search.fields.period'),
      }),
      (value) => Array.isArray(value) && value.length === 2 && value[0] != null && value[1] != null,
    ),
})

export default MaintenanceReportSearchBarSchema
